module.exports = __webpack_public_path__ + "img/software.a18e5fd6.png";